var React = require('react');

function IconAPI (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M223.5 319.7h77.3l159.8 383.9h-77.9l-38.9-78.9H178.2l-38.9 78.9h-75l159.2-383.9zm-25.6 249.9h126.7l-62.2-178.4h-1.7l-62.8 178.4zm302.2-249.9h183c29.4 0 53.5 4.3 72 12.8s32.9 19.2 43 32 16.9 26.7 20.6 41.8c3.7 15.1 5.5 29 5.5 41.8s-1.8 26.6-5.5 41.5-10.6 28.8-20.6 41.5c-10.1 12.8-24.4 23.3-43 31.7s-42.6 12.5-72 12.5H572.7v128.3h-72.6V319.7zm72.6 196.4H679c8.1 0 16.5-1.2 25-3.5s16.4-6.1 23.5-11.3c7.2-5.2 13-12.2 17.4-20.9 4.5-8.7 6.7-19.7 6.7-32.8 0-13.6-1.9-24.8-5.8-33.7-3.9-8.9-9.1-16-15.7-21.2-6.6-5.2-14.1-8.8-22.7-10.8-8.5-1.9-17.6-2.9-27.3-2.9H572.7v137.1zm314.9-196.4h72.6v383.9h-72.6V319.7z"}));
}

IconAPI.displayName = "IconAPI";

IconAPI.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconAPI;

IconAPI.default = IconAPI;
